<div class="nav-tabs">
  <ng-container *ngFor="let tab of tabs; let i = index">
    <div class="nav-tabs-tab" [ngClass]="[background, tab.isActive ? 'active' : '']" (click)="onSelectTab(i)">
      {{ tab.label }}
      <div [class]="tab.iconArrow"></div>
    </div>
  </ng-container>
</div>
